(function() {

    "use strict";

    angular
        .module("ATMGurus")
        .filter('lowercase', lowercase);

    function lowercase() {

        return function(string, scope) {

            return string.split(' ')
                .map(function(word){
                    return word.charAt(0).toLowerCase() + word.substr(1).toLowerCase()
                })
                .join(' ')
        }

    }

})()


// WEBPACK FOOTER //
// ./src/app/filters/lowercase.js